
import { 
  GET_EMPLOYER,
  GET_EMPLOYERS, GET_EMPLOYER_JOBS,
} from './constants';


export function getEmployers(page: number, search?: string) {
  return {
    type: GET_EMPLOYERS,
    page,
    search
  };
}

export function getEmployer(companySlug: string) {
  return {
    type: GET_EMPLOYER,
    companySlug
  }
}

export function getEmployerJobs(page: number, id: string, filter: string, searchParams?: string) {
  return {
    type: GET_EMPLOYER_JOBS,
    page,
    id,
    filter,
    searchParams
  };
}


